<template>
    <div>
        <el-dialog
        class="bidPriceList"
        :title="bidShowPayTitle"
        :visible.sync="bidShow"
        width="840px"
        :close-on-click-modal="false"
        @close="btnEvent('0')"
        height="600px">
            <div style="margin-top:10px;">盖章人信息</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="inforowData" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="stamperName" label="盖章人姓名" width="200" align="center">
                        <template slot-scope="scope">
                            <span class="info">{{scope.row.stamperName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stamperIdcard" label="盖章人身份证" width="200" align="center">
                        <template slot-scope="scope">
                            <span class="info">{{scope.row.stamperIdcard}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stamperMobile" label="盖章人联系方式" align="center">
                        <template slot-scope="scope">
                            <span class="info">{{scope.row.stamperMobile}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top:26px;">附件</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="bidFileInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="fileName" label="文件名称" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                            <span v-has="'06010020'">
                                <el-button size="mini" type="text" @click="actionFn(scope.row, '1')">下载</el-button>
                            </span>
                            <span class="margin-left" v-has="'06010019'">
                                <el-button size="mini" type="text" @click="actionFn(scope.row, '2')">预览</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="rowInfo.supplierBidStatus === '13' || rowInfo.costStatus === '7'" :loading="btnload"
                    type="primary" @click="bidSeal">撤回</el-button>
                <el-button v-else-if="rowInfo.supplierBidStatus === '12' || rowInfo.costStatus === '1'" :loading="btnload"
                    type="primary" @click="btnEvent('1')">推送盖章</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import config from '@/config/user.env.js';
import { filePreview } from '@/utils/filePreview.js';
import { getSupplierStamperInfo, bidWinning, sendRefundStamp, bidSealWithdrawal } from '../../../../lsrm/api/myBidding.js';
import { moduleFile } from '../../../../lsrm/api/annoMana.js';
export default {
    components: { },
    props: {
        originFlag: {
            type: String // 1中标价格表盖章  2退款申请函盖章
        },
        payTitle: {
            type: String
        },
        MDialogshow: {
            type: Boolean
        },
        rowBidDialogData: {
            type: Object,
            default() {
                return {};
            }
        },
        refundFileInfo: {
            type: Array,
            default() {
                return [];
            }
        }

    },
    data() {
        return {
            inforowData: [],
            rowInfo: {},
            bidShow: false,
            bidFileInfo: [],
            bidShowPayTitle: '',
            btnload: false
        };
    },
    methods: {
        actionFn(row, type, index) {
            if (type === '1') {
                const url = row.downUrl || row.fileUrl;
                window.open(url, '_parent');
            } else {
                filePreview(row);
            }
        },
        getSupInfo(val) {
            getSupplierStamperInfo(val).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data;
                    data.stamperIdcard = data.stamperIdcard.replace(/(\d{6})\d{6}(\d{3})/, '$1******$2');
                    this.inforowData[0] = data;
                    this.inforowData = [...this.inforowData];
                }
            });
        },
        getFile() {
            if (this.originFlag === '1') {
                const fileAttribute = this.rowInfo.supplierBidStatus === '9' ? '22' : '21';
                const par = { fileAttribute: fileAttribute, moduleNo: this.rowInfo.bidNo + '_' + this.rowInfo.supplierCode + '_ZBJG' };
                moduleFile(par).then(res => {
                    this.bidFileInfo = res.data.list;
                });
            } else {
                const par = { moduleNo: this.rowInfo.orderNo };
                moduleFile(par).then(res => {
                    const listdata = res.data.list || [];
                    if (listdata.length > 1) {
                        const listdataForm = [...listdata];
                        listdataForm.forEach(el => {
                            el.createTime = new Date(el.createTime).getTime();
                        });
                        const newtime = Math.max.apply(Math, listdataForm.map(function(o) { return o.createTime; }));
                        const data = listdataForm.find(el => {
                            return el.createTime === newtime;
                        });
                        this.bidFileInfo = [];
                        this.bidFileInfo.push(data);
                    } else {
                        this.bidFileInfo = listdata;
                    }
                });
            }
        },
        bidSeal() {
            this.btnload = true;
            const par = {
                bidNo: this.rowInfo.bidNo,
                suppliersCode: this.rowInfo.supplierCode,
                cancelType: this.originFlag === '1' ? '2' : '3', // 撤回盖章类型，1：应标文件 2：中标价格 3：退款单
                orderNo: this.rowInfo.orderNo,
                operatorName: this.rowInfo.supplierName
            };
            bidSealWithdrawal(par).then(res => {
                this.btnload = false;
                if (res && +res.code === 0) {
                    this.$message.success('撤回成功！');
                    this.bidShow = false;
                    this.$emit('mdialogFn', 1);
                    if (this.originFlag === '1') {
                        this.$router.push({ name: 'myBidding' });
                    } else {
                        this.$router.push({ name: 'tenderCost' });
                    }
                }
            });
        },
        btnEvent(type) {
            if (type === '1') {
                this.btnload = true;
                const stampUrl = `${config.stampUrl}/html/index.html#/index/home`;
                if (this.originFlag === '1') {
                    bidWinning({ id: this.rowInfo.id }).then(res => {
                        this.btnload = false;
                        if (res && +res.code === 0) {
                            this.bidShow = false;
                            this.$message.success('推送盖章成功！');
                            if (window.location.hash === '#/lsrm/myBidding') {
                                this.$emit('mdialogFn', 1);
                                const tempwindow = window.open('_blank');
                                tempwindow.location = stampUrl.replace(/'/g, '');
                            } else {
                                const tempwindow = window.open('_blank');
                                tempwindow.location = stampUrl.replace(/'/g, '');
                            }
                        }
                    });
                } else {
                    sendRefundStamp({ id: this.rowInfo.id, bidNo: this.rowInfo.bidNo, supplierCode: this.rowInfo.supplierCode }).then(res => {
                        this.btnload = false;
                        if (res && +res.code === 0) {
                            this.bidShow = false;
                            this.$emit('mdialogFn', 1);
                            this.$message.success('推送盖章成功！');
                            const tempwindow = window.open('_blank');
                            tempwindow.location = stampUrl.replace(/'/g, '');
                        }
                    });
                }
            } else {
                this.bidShow = false;
                this.$emit('mdialogFn');
            }
        }
    },
    watch: {
        MDialogshow(val) {
            this.bidShow = val;
            this.bidShowPayTitle = this.payTitle;
        },
        rowBidDialogData: {
            handler(val, oldval) {
                if (val) {
                    this.rowInfo = val;
                    if (this.originFlag === '1') {
                        this.bidShowPayTitle = (val.bidStatus === '50' && val.supplierBidStatus === '9') ? '中标价格表预览' : '中标价格表盖章';
                    } else {
                        this.bidShowPayTitle = val.orderType === '3' && (val.costStatus === '1' || val.costStatus === '7') ? '退款申请函盖章' : '退款申请函预览';
                    }
                    this.getSupInfo(val.supplierCode);
                    this.getFile();
                }
            },
            deep: true
        },
        refundFileInfo: {
            handler(val, oldval) {
                if (val) {
                    this.bidFileInfo = val;
                }
            },
            deep: true
        }

    }
};
</script>

<style lang="less">
.bidPriceList {
    .margin-left {
        margin-left: 10px;
    }
    .info {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .el-table__row {
        font-size: 12px;
    }
}
</style>